import { render, staticRenderFns } from "./ConfirmProcurementPusat.vue?vue&type=template&id=9739c80a&"
import script from "./ConfirmProcurementPusat.vue?vue&type=script&lang=js&"
export * from "./ConfirmProcurementPusat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports